//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CenterScreenObserver from '@/components/universal/invisible/CenterScreenObserver.vue'

export default {
  name: 'VerticalStepList',
  components: {
    CenterScreenObserver,
  },
  props: {
    stepList: Array,
  },
  data() {
    return {
      dimensions: { width: 0, height: 0 },
    }
  },
  computed: {
    paddingHeight() {
      return this.dimensions.height / 2
    },
  },
  watch: {
    stepList(newValue = [], oldValue = []) {
      const newLastKey = newValue.length ? newValue[newValue.length - 1].key : undefined
      const oldLastKey = oldValue.length ? oldValue[oldValue.length - 1].key : undefined
      if (newLastKey !== oldLastKey) {
        this.scrollToLatestStep(true)
      }
    },
    dimensions() {
      this.scrollToLatestStep(true)
    },
  },
  methods: {
    scrollToStep(event) {
      const { $el } = this
      const { offsetHeight, offsetTop } = event.currentTarget
      $el.scrollTo({
        top: offsetTop + offsetHeight / 2 - $el.offsetHeight / 2,
        left: 0,
        behavior: 'smooth',
      })
    },
    scrollToLatestStep(smooth) {
      setTimeout(() => {
        const { $el } = this
        $el.scrollTo({
          top: $el.scrollHeight - $el.offsetHeight,
          left: 0,
          behavior: smooth ? 'smooth' : 'auto',
        })
        setTimeout(() => {
          const { steps } = this.$refs
          if (steps.length) {
            const inputs = steps[steps.length - 1].getElementsByTagName('INPUT')
            const focusableInputs = Array.prototype.filter.call(inputs, input => {
              if(!input.getAttribute('preventautofocus')) return input
            })
            if (focusableInputs.length) focusableInputs[0].focus()
          }
        }, 500)
      }, 500)
    },
  },
  mounted() {
    this.scrollToLatestStep()
  },
}
